<script lang="ts">
	import { DataHandlerScene, DataHandlerDevice, DataHandlerTag } from "luxedo-data"

	import type { QuickActions } from "@lux-ai/client"

	import { LuxAi, mockLuxAiApi } from "@lux-ai/client"
	import { openCalibrationOverlay } from "../../reusable/overlays/calibration"
	import { openShowOverview } from "../../reusable/overlays"
	import { navigateTo } from "../../../stores/NavigationContext"
	import { Responsive } from "responsive"
	import { ProjectorMenuController } from "../projectors/ProjectorMenuController.svelte"
	import { getLuxAiApi, LuxAiApi } from "./LuxAiApi"

	import { Toast } from "toaster"
	import { deviceDataGetter, userDataAdapter } from "./DataAdapters"
	import { LUX_AI_SUBSCRIPTION_LINK } from "../../../modules/subscription-management/subscriptionLinks"

	const quickActions: QuickActions = {
		calibrateDevice: (deviceId: string) => {
			navigateTo("projector")
			const dev = DataHandlerDevice.get(Number(deviceId))
			openCalibrationOverlay(dev)
		},
		viewScene: (sceneId: number) => {
			const scene = DataHandlerScene.get(sceneId)

			// navigateTo("show-library")

			// If the scene loaded without a hitch, open it
			if (scene) {
				openShowOverview(scene)

				// If the scene wasn't loaded (likely due to the scene having just been generated), pull it
			} else {
				Promise.all([DataHandlerScene.pull([sceneId]), DataHandlerTag.pull()])
					.then(() => {
						const scene = DataHandlerScene.get(sceneId)
						openShowOverview(scene)
					})
					.catch((e) => {
						Toast.error("Unable to open show at this time. Please refresh and try again.")
					})
			}
		},
		jumpToSubscribe: () => {
			window.open(LUX_AI_SUBSCRIPTION_LINK, "_blank")
		},
		jumpToRegister: () => {
			navigateTo("projector")
			ProjectorMenuController.setView("Registration")
		},
	}

	let api: LuxAiApi = getLuxAiApi()
</script>

<div id="lux-ai" class:mobile={Responsive.isMobile}>
	<LuxAi {quickActions} {api} userDataGetter={userDataAdapter} {deviceDataGetter} />
</div>

<style>
	#lux-ai {
		height: 100%;
		width: 100%;
		padding: 0.5rem 0;
	}

	#lux-ai.mobile {
		padding: 1rem 0.5rem;
	}
</style>
